import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Tab, Tabs } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  container: { flexGrow: 1, display: 'flex', maxWidth: '100%', height: 300, zIndex: '0' },
  size: { fontWeight: 'none', fontSize: '12px' },
}));

function KeySpinner({ tab, changeMeasurement, availableReadingTypes }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const changeTab = (event, tab) => {
    changeMeasurement(tab);
  };

  return (
    <Box className={classes.container}>
      <Tabs value={tab} onChange={changeTab} variant="scrollable" orientation="vertical" scrollButtons="on">
        {availableReadingTypes.map((key, index) => (
          <Tab className={classes.size} key={index} label={t(key.measurement)} />
        ))}
      </Tabs>
    </Box>
  );
}

KeySpinner.propTypes = {
  tab: PropTypes.number,
  changeMeasurement: PropTypes.func.isRequired,
  availableReadingTypes: PropTypes.array,
};

KeySpinner.defaultProps = {
  tab: 0,
  availableReadingTypes: [],
};

export default KeySpinner;
